export default "__VITE_ASSET__C0iCpTf0__"